import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import React, { Suspense } from "react";
import PictureSetsProvider from "../providers/PictureSetsProvider";
import TemplateInstanceProvider from "../../Providers/TemplateInstanceProvider";
import { Redirect } from "react-router";
import { CssBaseline } from "@mui/material";
import { ShoppingCartProvider } from "../providers/ShoppingCartProvider";
import PriceListProvider from "../providers/PriceListProvider";
import useRoutes from "../hooks/useRoutes";
import AuthProvider, { useAuth } from "../providers/AuthProvider";
import PortalProvider from "../../Providers/PortalProvider";
import LoaderInterwind from "./Components/LoaderInterwind";
import RecentImagesProvider from "./Providers/RecentImagesProvider";
import DisplayDialogs from "../../components/DisplayDialogs";
import NetlifeConsentBanner from "./Components/NetlifeConsentBanner";
import VirtualPageView from "./Components/VirtualPageView";

const ProtectedRoute = (props) => {
  const { isAuthenticating, isAuthenticated, setReferrer } = useAuth();
  // FIXME:
  if (isAuthenticating) {
    return null; // Loader?
  }

  if (isAuthenticated) {
    return <Route {...props} />;
  } else {
    let referrer = props.location.pathname;
    if (props.location.search) {
      referrer += props.location.search;
    }
    setReferrer(referrer);
    return <Redirect to="/" />;
  }
};

const Providers = () => {
  return (
    <Suspense fallback={<MainLoader />}>
      <PortalProvider>
        <AuthProvider>
          <PriceListProvider>
            <TemplateInstanceProvider>
              <PictureSetsProvider>
                <ShoppingCartProvider>
                  <RecentImagesProvider>
                    <CssBaseline />
                    <div>
                      <PageRouter />
                    </div>
                  </RecentImagesProvider>
                </ShoppingCartProvider>
              </PictureSetsProvider>
            </TemplateInstanceProvider>
          </PriceListProvider>
        </AuthProvider>
      </PortalProvider>
    </Suspense>
  );
};

const PageRouter = () => {
  const routes = useRoutes();
  const { user } = useAuth();

  // Track page views if allowed. Pages will be tracked twice(?) if we
  // change language, but or we log in(?), but that's ok for now.
  if (window.isEpmsAnalyticsFeatureEnabled && window.epmsAnalytics) {
    window.epmsAnalytics.onPageUser(user);
  }

  return (
    <Router basename="/m">
      {/* Outside the Switch: it has to see every route, not just a match. */}
      <VirtualPageView />
      <Switch>
        {Object.values(routes).map((route, index) => {
          const exact =
            typeof route.exact == "undefined" || route.exact == true
              ? true
              : false;
          return route.protected ? (
            <ProtectedRoute
              key={index}
              path={route.path}
              component={route.component}
              exact={exact}
            />
          ) : (
            <Route
              key={index}
              path={route.path}
              component={route.component}
              exact={exact}
            />
          );
        })}
        <Route component={UndefinedRoute} />

        <WhereAmI />
      </Switch>
      <DisplayDialogs />
      <NetlifeConsentBanner />
    </Router>
  );
};

export default Providers;

const WhereAmI = () => {
  return null;
};

const MainLoader = () => {
  return <LoaderInterwind />;
};

const UndefinedRoute = () => {
  return (
    <>
      <h4>Page not found</h4>
      <p>The url {window.location.href} was not found</p>
    </>
  );
};
